import React from "react";
import { View, StyleSheet, Text } from "react-native";
import { MotiView } from "moti";
import { Users, ChatCircle, Clock, Question } from "@phosphor-icons/react";

import { StatCard } from "../../../components/adminDashboard/AICompanion";
import { colors, spacing } from "../../../styles/design-system";

type Props = {
  totalUsers: number;
  totalSessions: number;
  avgSessionLength: number;
  questionsAnswered: number;
  assignmentQuestions: number;
  courseQuestions: number;
};

export default function FacultyStatsCards({
  totalUsers,
  totalSessions,
  avgSessionLength,
  questionsAnswered,
  assignmentQuestions,
  courseQuestions,
}: Props) {
  return (
    <MotiView
      from={{ opacity: 0, translateY: 20 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ type: "timing", duration: 500, delay: 100 }}
      style={styles.statsGrid}>
      <StatCard
        title="Total Users"
        value={totalUsers.toLocaleString()}
        change=""
        changeType="positive"
        icon={Users}
        color="blue"
      />

      <StatCard
        title="Total Sessions"
        value={totalSessions.toLocaleString()}
        change=""
        changeType="positive"
        icon={ChatCircle}
        color="purple"
      />

      <StatCard
        title="Avg. Session Length"
        value={`${avgSessionLength} min`}
        change=""
        changeType="positive"
        icon={Clock}
        color="green"
      />
      <StatCard
        title="Questions Answered"
        value={questionsAnswered.toLocaleString()}
        change=""
        changeType="positive"
        icon={Question}
        color="blue"
        footer={
          <View style={styles.footerInline}>
            <View style={styles.footerRow}>
              <Text style={styles.footerText}>{assignmentQuestions} assignment</Text>
            </View>

            <View style={styles.footerRow}>
              <Text style={styles.footerDot}>·</Text>
              <Text style={styles.footerText}>{courseQuestions} course</Text>
            </View>
          </View>
        }
      />
    </MotiView>
  );
}

const styles = StyleSheet.create({
  footerInline: {
    flexDirection: "row",
    flexWrap: "wrap",
    columnGap: 12,
    rowGap: 4,
    alignItems: "center",
  },
  footerRow: {
    flexDirection: "row",
    alignItems: "baseline",
  },

  footerText: {
    fontSize: 12,
    color: colors.grey[600],
  },

  footerDot: {
    fontSize: 12,
    color: colors.grey[400],
    marginHorizontal: 6,
    lineHeight: 12,
  },

  statsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.lg,
    marginBottom: spacing.xl,
    alignItems: "flex-start",
  },
});
